export const FOS_TEST_SUITE_OPTIONS = [
{ id: 'Platform_performance', value: 'Platform_performance', label: 'Platform_performance' },
{ id: 'Platform_regression_stage1', value: 'Platform_regression_stage1', label: 'Platform_regression_stage1' },
{ id: 'Platform_regression_stage2', value: 'Platform_regression_stage2', label: 'Platform_regression_stage2' },
{ id: 'Platform_regression_stage3', value: 'Platform_regression_stage3', label: 'Platform_regression_stage3' }
]